import { Link } from "react-router-dom";
import { Wordmark, scrollToId } from "./Nav";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink/10 py-14">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <Wordmark />
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink/60">
              Helping private dental practices convert more enquiries into
              consultations.
            </p>
          </div>
          <nav className="flex items-center gap-8" aria-label="Footer">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-sm text-ink/60 transition-colors hover:text-teal"
            >
              Privacy
            </Link>
            <button
              data-testid="footer-contact-link"
              onClick={() => scrollToId("contact")}
              className="text-sm text-ink/60 transition-colors hover:text-teal"
            >
              Contact
            </button>
            <Link
              to="/admin/login"
              rel="nofollow"
              data-testid="footer-admin-link"
              className="text-sm text-ink/60 transition-colors hover:text-teal"
            >
              Admin
            </Link>
          </nav>
        </div>
        <p className="mt-10 border-t border-ink/10 pt-6 text-xs text-ink/45">
          © {new Date().getFullYear()} Leadtochair. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
